import React, {useState} from "react";
import Modal from "../../components/modal/modal.component";
import Form from "../../components/form";
import {StyledModalContent} from "../../components/modal/modal.style";
import {StyledFooter} from "../../components/pane/pane.style";
import {useTranslation} from "react-i18next";
import {StyledOption} from "../../components/options/options.style";
import {saveSurveySource} from "../../services/recruitment.service";
import {logout, useAuth} from "../../services/auth.service";
import {Links} from "../../app/links";
import {useHistory} from 'react-router-dom';
import {StyledWiteButton} from "../../components/button/button.style";
import LogoffImage from "../../assets/images/log-out.svg";
import {disableSwipeToClose} from "../../utils/tools/modals";
import {SurveySource} from "../../models/recruitmentPathData";

type SurveySourceModalProps = {
    isOpen: boolean;
    hash: string;
    sources: SurveySource[];
    onClose: () => void;
    onSubmit: () => void;
};

const SurveySourceModal: React.FC<SurveySourceModalProps> = (props: SurveySourceModalProps) => {
    const {t} = useTranslation();
    const history = useHistory();
    const auth = useAuth();

    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [saving, setSaving] = useState<boolean>(false);

    const handleSave = async () => {
        if (selectedId === null || saving) {
            return;
        }

        setSaving(true);
        await saveSurveySource(props.hash, selectedId)
            .then(() => {
                props.onSubmit();
                props.onClose();
            })
            .catch(() => {
                setSaving(false);
            });
    };

    const logoutClick = async () => {
        await logout().then(() => {
            auth.signOut();
            history.replace(Links.login)
            window.location.reload();
        });
    };

    return (
        <Modal
            isOpen={props.isOpen}
            canDismiss={disableSwipeToClose}
            disableClose={true}
            backdropDismiss={false}
            onDidDismiss={() => props.onClose()}>
            <StyledModalContent>
                <h1 className="title full">{t("surveySourceModal.title")}</h1>
                <div className="content">
                    <p>{t("surveySourceModal.subtitle")}</p>
                    {props.sources.map((source: SurveySource) => (
                        <StyledOption
                            key={source.id}
                            className={selectedId === source.id ? 'selected' : ''}
                            onClick={() => setSelectedId(source.id)}>{source.name}</StyledOption>
                    ))}
                </div>
                <StyledFooter className="modal footer no-shadow">
                    <Form.Button
                        onClick={() => handleSave()}
                        disabled={selectedId === null || saving}>{t("surveySourceModal.submit")}</Form.Button>
                    <StyledWiteButton onClick={() => logoutClick()}>{t("settingsTab.logoff")} <img src={LogoffImage}/></StyledWiteButton>
                </StyledFooter>
            </StyledModalContent>
        </Modal>
    );
};

export default SurveySourceModal;
